/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AddIndividualPracticeRequest } from '../models';
import { BooleanResponse } from '../models';
import { ExternalExaminerTipResponse } from '../models';
import { IndividualPracticeDetailsResponse } from '../models';
import { IndividualPracticeRequest } from '../models';
import { IndividualPracticeSummaryForExternalExaminerIEnumerableResponse } from '../models';
import { PracticeAtcsIEnumerableResponse } from '../models';
import { PracticeSearchForEeIEnumerableResponse } from '../models';
import { Request } from '../models';
import { TerminateExternalExaminerRequest } from '../models';
import { TerminateIndividualPracticeRequest } from '../models';
/**
 * PracticeAtcsApi - axios parameter creator
 * @export
 */
export const PracticeAtcsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAll | Save Individual Practice For External Examiner
         * @param {number} externalExaminerId 
         * @param {AddIndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminAddIndividualPracticeForExternalExaminerExternalExaminerIdPost: async (externalExaminerId: number, body?: AddIndividualPracticeRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalExaminerId' is not null or undefined
            if (externalExaminerId === null || externalExaminerId === undefined) {
                throw new RequiredError('externalExaminerId','Required parameter externalExaminerId was null or undefined when calling apiV2AtcsPracticeAdminAddIndividualPracticeForExternalExaminerExternalExaminerIdPost.');
            }
            const localVarPath = `/api/v2/Atcs/Practice/Admin/AddIndividualPracticeForExternalExaminer/{externalExaminerId}`
                .replace(`{${"externalExaminerId"}}`, encodeURIComponent(String(externalExaminerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminGetExternalExaminerByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2AtcsPracticeAdminGetExternalExaminerByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Atcs/Practice/Admin/GetExternalExaminerByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns Individual Practice
         * @param {number} individualPracticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminGetIndividualPracticeForExternalExaminerIndividualPracticeIdGet: async (individualPracticeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'individualPracticeId' is not null or undefined
            if (individualPracticeId === null || individualPracticeId === undefined) {
                throw new RequiredError('individualPracticeId','Required parameter individualPracticeId was null or undefined when calling apiV2AtcsPracticeAdminGetIndividualPracticeForExternalExaminerIndividualPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Atcs/Practice/Admin/GetIndividualPracticeForExternalExaminer/{individualPracticeId}`
                .replace(`{${"individualPracticeId"}}`, encodeURIComponent(String(individualPracticeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Individual Practices
         * @param {number} externalExaminerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminGetIndividualPracticesForExternalExaminerExternalExaminerIdGet: async (externalExaminerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalExaminerId' is not null or undefined
            if (externalExaminerId === null || externalExaminerId === undefined) {
                throw new RequiredError('externalExaminerId','Required parameter externalExaminerId was null or undefined when calling apiV2AtcsPracticeAdminGetIndividualPracticesForExternalExaminerExternalExaminerIdGet.');
            }
            const localVarPath = `/api/v2/Atcs/Practice/Admin/GetIndividualPracticesForExternalExaminer/{externalExaminerId}`
                .replace(`{${"externalExaminerId"}}`, encodeURIComponent(String(externalExaminerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAdmin | Save Trust Contact for TA
         * @param {IndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminSaveTrustContactPost: async (body?: IndividualPracticeRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/Practice/Admin/SaveTrustContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAdmin | Save Trust Coordinator for TA
         * @param {IndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminSaveTrustCoordinatorPost: async (body?: IndividualPracticeRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/Practice/Admin/SaveTrustCoordinator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns Practices
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminSearchPracticeForExternalExaminerPost: async (body?: Request, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/Practice/Admin/SearchPracticeForExternalExaminer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Terminate Individual Practice
         * @param {TerminateExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminTerminateExternalExaminerPost: async (body?: TerminateExternalExaminerRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/Practice/Admin/TerminateExternalExaminer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Terminate Individual Practice
         * @param {TerminateIndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminTerminateIndividualPracticeForExternalExaminerPost: async (body?: TerminateIndividualPracticeRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/Practice/Admin/TerminateIndividualPracticeForExternalExaminer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal | Save Trust Coordinator
         * @param {number} practiceCoreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAssignSelfTrustCoordinatorPracticeCoreIdPost: async (practiceCoreId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceCoreId' is not null or undefined
            if (practiceCoreId === null || practiceCoreId === undefined) {
                throw new RequiredError('practiceCoreId','Required parameter practiceCoreId was null or undefined when calling apiV2AtcsPracticeAssignSelfTrustCoordinatorPracticeCoreIdPost.');
            }
            const localVarPath = `/api/v2/Atcs/Practice/AssignSelfTrustCoordinator/{practiceCoreId}`
                .replace(`{${"practiceCoreId"}}`, encodeURIComponent(String(practiceCoreId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / TrustContact | Returns Practices (Not Branches)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeGetMyPracticesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/Practice/GetMyPractices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal | Save Trust Contact
         * @param {IndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeSaveTrustContactPost: async (body?: IndividualPracticeRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/Practice/SaveTrustContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracticeAtcsApi - functional programming interface
 * @export
 */
export const PracticeAtcsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAll | Save Individual Practice For External Examiner
         * @param {number} externalExaminerId 
         * @param {AddIndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPracticeAdminAddIndividualPracticeForExternalExaminerExternalExaminerIdPost(externalExaminerId: number, body?: AddIndividualPracticeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PracticeAtcsApiAxiosParamCreator(configuration).apiV2AtcsPracticeAdminAddIndividualPracticeForExternalExaminerExternalExaminerIdPost(externalExaminerId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPracticeAdminGetExternalExaminerByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalExaminerTipResponse>> {
            const localVarAxiosArgs = await PracticeAtcsApiAxiosParamCreator(configuration).apiV2AtcsPracticeAdminGetExternalExaminerByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns Individual Practice
         * @param {number} individualPracticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPracticeAdminGetIndividualPracticeForExternalExaminerIndividualPracticeIdGet(individualPracticeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualPracticeDetailsResponse>> {
            const localVarAxiosArgs = await PracticeAtcsApiAxiosParamCreator(configuration).apiV2AtcsPracticeAdminGetIndividualPracticeForExternalExaminerIndividualPracticeIdGet(individualPracticeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Individual Practices
         * @param {number} externalExaminerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPracticeAdminGetIndividualPracticesForExternalExaminerExternalExaminerIdGet(externalExaminerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualPracticeSummaryForExternalExaminerIEnumerableResponse>> {
            const localVarAxiosArgs = await PracticeAtcsApiAxiosParamCreator(configuration).apiV2AtcsPracticeAdminGetIndividualPracticesForExternalExaminerExternalExaminerIdGet(externalExaminerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAdmin | Save Trust Contact for TA
         * @param {IndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPracticeAdminSaveTrustContactPost(body?: IndividualPracticeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PracticeAtcsApiAxiosParamCreator(configuration).apiV2AtcsPracticeAdminSaveTrustContactPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAdmin | Save Trust Coordinator for TA
         * @param {IndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPracticeAdminSaveTrustCoordinatorPost(body?: IndividualPracticeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PracticeAtcsApiAxiosParamCreator(configuration).apiV2AtcsPracticeAdminSaveTrustCoordinatorPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns Practices
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPracticeAdminSearchPracticeForExternalExaminerPost(body?: Request, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticeSearchForEeIEnumerableResponse>> {
            const localVarAxiosArgs = await PracticeAtcsApiAxiosParamCreator(configuration).apiV2AtcsPracticeAdminSearchPracticeForExternalExaminerPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Terminate Individual Practice
         * @param {TerminateExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPracticeAdminTerminateExternalExaminerPost(body?: TerminateExternalExaminerRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PracticeAtcsApiAxiosParamCreator(configuration).apiV2AtcsPracticeAdminTerminateExternalExaminerPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Terminate Individual Practice
         * @param {TerminateIndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPracticeAdminTerminateIndividualPracticeForExternalExaminerPost(body?: TerminateIndividualPracticeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PracticeAtcsApiAxiosParamCreator(configuration).apiV2AtcsPracticeAdminTerminateIndividualPracticeForExternalExaminerPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal | Save Trust Coordinator
         * @param {number} practiceCoreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPracticeAssignSelfTrustCoordinatorPracticeCoreIdPost(practiceCoreId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PracticeAtcsApiAxiosParamCreator(configuration).apiV2AtcsPracticeAssignSelfTrustCoordinatorPracticeCoreIdPost(practiceCoreId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / TrustContact | Returns Practices (Not Branches)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPracticeGetMyPracticesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticeAtcsIEnumerableResponse>> {
            const localVarAxiosArgs = await PracticeAtcsApiAxiosParamCreator(configuration).apiV2AtcsPracticeGetMyPracticesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal | Save Trust Contact
         * @param {IndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPracticeSaveTrustContactPost(body?: IndividualPracticeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PracticeAtcsApiAxiosParamCreator(configuration).apiV2AtcsPracticeSaveTrustContactPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PracticeAtcsApi - factory interface
 * @export
 */
export const PracticeAtcsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TaAll | Save Individual Practice For External Examiner
         * @param {number} externalExaminerId 
         * @param {AddIndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminAddIndividualPracticeForExternalExaminerExternalExaminerIdPost(externalExaminerId: number, body?: AddIndividualPracticeRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PracticeAtcsApiFp(configuration).apiV2AtcsPracticeAdminAddIndividualPracticeForExternalExaminerExternalExaminerIdPost(externalExaminerId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminGetExternalExaminerByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<ExternalExaminerTipResponse> {
            return PracticeAtcsApiFp(configuration).apiV2AtcsPracticeAdminGetExternalExaminerByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns Individual Practice
         * @param {number} individualPracticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminGetIndividualPracticeForExternalExaminerIndividualPracticeIdGet(individualPracticeId: number, options?: any): AxiosPromise<IndividualPracticeDetailsResponse> {
            return PracticeAtcsApiFp(configuration).apiV2AtcsPracticeAdminGetIndividualPracticeForExternalExaminerIndividualPracticeIdGet(individualPracticeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Individual Practices
         * @param {number} externalExaminerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminGetIndividualPracticesForExternalExaminerExternalExaminerIdGet(externalExaminerId: number, options?: any): AxiosPromise<IndividualPracticeSummaryForExternalExaminerIEnumerableResponse> {
            return PracticeAtcsApiFp(configuration).apiV2AtcsPracticeAdminGetIndividualPracticesForExternalExaminerExternalExaminerIdGet(externalExaminerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAdmin | Save Trust Contact for TA
         * @param {IndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminSaveTrustContactPost(body?: IndividualPracticeRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PracticeAtcsApiFp(configuration).apiV2AtcsPracticeAdminSaveTrustContactPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAdmin | Save Trust Coordinator for TA
         * @param {IndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminSaveTrustCoordinatorPost(body?: IndividualPracticeRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PracticeAtcsApiFp(configuration).apiV2AtcsPracticeAdminSaveTrustCoordinatorPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns Practices
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminSearchPracticeForExternalExaminerPost(body?: Request, options?: any): AxiosPromise<PracticeSearchForEeIEnumerableResponse> {
            return PracticeAtcsApiFp(configuration).apiV2AtcsPracticeAdminSearchPracticeForExternalExaminerPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Terminate Individual Practice
         * @param {TerminateExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminTerminateExternalExaminerPost(body?: TerminateExternalExaminerRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PracticeAtcsApiFp(configuration).apiV2AtcsPracticeAdminTerminateExternalExaminerPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Terminate Individual Practice
         * @param {TerminateIndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAdminTerminateIndividualPracticeForExternalExaminerPost(body?: TerminateIndividualPracticeRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PracticeAtcsApiFp(configuration).apiV2AtcsPracticeAdminTerminateIndividualPracticeForExternalExaminerPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal | Save Trust Coordinator
         * @param {number} practiceCoreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeAssignSelfTrustCoordinatorPracticeCoreIdPost(practiceCoreId: number, options?: any): AxiosPromise<BooleanResponse> {
            return PracticeAtcsApiFp(configuration).apiV2AtcsPracticeAssignSelfTrustCoordinatorPracticeCoreIdPost(practiceCoreId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / TrustContact | Returns Practices (Not Branches)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeGetMyPracticesGet(options?: any): AxiosPromise<PracticeAtcsIEnumerableResponse> {
            return PracticeAtcsApiFp(configuration).apiV2AtcsPracticeGetMyPracticesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal | Save Trust Contact
         * @param {IndividualPracticeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPracticeSaveTrustContactPost(body?: IndividualPracticeRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PracticeAtcsApiFp(configuration).apiV2AtcsPracticeSaveTrustContactPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracticeAtcsApi - object-oriented interface
 * @export
 * @class PracticeAtcsApi
 * @extends {BaseAPI}
 */
export class PracticeAtcsApi extends BaseAPI {
    /**
     * 
     * @summary TaAll | Save Individual Practice For External Examiner
     * @param {number} externalExaminerId 
     * @param {AddIndividualPracticeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAtcsApi
     */
    public apiV2AtcsPracticeAdminAddIndividualPracticeForExternalExaminerExternalExaminerIdPost(externalExaminerId: number, body?: AddIndividualPracticeRequest, options?: any) {
        return PracticeAtcsApiFp(this.configuration).apiV2AtcsPracticeAdminAddIndividualPracticeForExternalExaminerExternalExaminerIdPost(externalExaminerId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns External Examiner
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAtcsApi
     */
    public apiV2AtcsPracticeAdminGetExternalExaminerByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return PracticeAtcsApiFp(this.configuration).apiV2AtcsPracticeAdminGetExternalExaminerByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns Individual Practice
     * @param {number} individualPracticeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAtcsApi
     */
    public apiV2AtcsPracticeAdminGetIndividualPracticeForExternalExaminerIndividualPracticeIdGet(individualPracticeId: number, options?: any) {
        return PracticeAtcsApiFp(this.configuration).apiV2AtcsPracticeAdminGetIndividualPracticeForExternalExaminerIndividualPracticeIdGet(individualPracticeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns External Examiner Individual Practices
     * @param {number} externalExaminerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAtcsApi
     */
    public apiV2AtcsPracticeAdminGetIndividualPracticesForExternalExaminerExternalExaminerIdGet(externalExaminerId: number, options?: any) {
        return PracticeAtcsApiFp(this.configuration).apiV2AtcsPracticeAdminGetIndividualPracticesForExternalExaminerExternalExaminerIdGet(externalExaminerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAdmin | Save Trust Contact for TA
     * @param {IndividualPracticeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAtcsApi
     */
    public apiV2AtcsPracticeAdminSaveTrustContactPost(body?: IndividualPracticeRequest, options?: any) {
        return PracticeAtcsApiFp(this.configuration).apiV2AtcsPracticeAdminSaveTrustContactPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAdmin | Save Trust Coordinator for TA
     * @param {IndividualPracticeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAtcsApi
     */
    public apiV2AtcsPracticeAdminSaveTrustCoordinatorPost(body?: IndividualPracticeRequest, options?: any) {
        return PracticeAtcsApiFp(this.configuration).apiV2AtcsPracticeAdminSaveTrustCoordinatorPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns Practices
     * @param {Request} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAtcsApi
     */
    public apiV2AtcsPracticeAdminSearchPracticeForExternalExaminerPost(body?: Request, options?: any) {
        return PracticeAtcsApiFp(this.configuration).apiV2AtcsPracticeAdminSearchPracticeForExternalExaminerPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Terminate Individual Practice
     * @param {TerminateExternalExaminerRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAtcsApi
     */
    public apiV2AtcsPracticeAdminTerminateExternalExaminerPost(body?: TerminateExternalExaminerRequest, options?: any) {
        return PracticeAtcsApiFp(this.configuration).apiV2AtcsPracticeAdminTerminateExternalExaminerPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Terminate Individual Practice
     * @param {TerminateIndividualPracticeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAtcsApi
     */
    public apiV2AtcsPracticeAdminTerminateIndividualPracticeForExternalExaminerPost(body?: TerminateIndividualPracticeRequest, options?: any) {
        return PracticeAtcsApiFp(this.configuration).apiV2AtcsPracticeAdminTerminateIndividualPracticeForExternalExaminerPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal | Save Trust Coordinator
     * @param {number} practiceCoreId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAtcsApi
     */
    public apiV2AtcsPracticeAssignSelfTrustCoordinatorPracticeCoreIdPost(practiceCoreId: number, options?: any) {
        return PracticeAtcsApiFp(this.configuration).apiV2AtcsPracticeAssignSelfTrustCoordinatorPracticeCoreIdPost(practiceCoreId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / TrustContact | Returns Practices (Not Branches)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAtcsApi
     */
    public apiV2AtcsPracticeGetMyPracticesGet(options?: any) {
        return PracticeAtcsApiFp(this.configuration).apiV2AtcsPracticeGetMyPracticesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal | Save Trust Contact
     * @param {IndividualPracticeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAtcsApi
     */
    public apiV2AtcsPracticeSaveTrustContactPost(body?: IndividualPracticeRequest, options?: any) {
        return PracticeAtcsApiFp(this.configuration).apiV2AtcsPracticeSaveTrustContactPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
